import React, { useState, useEffect } from 'react';
import { Table, ConfigProvider } from 'antd';
import { DeleteUnidadeGerencia, GetAllUnidadesGerencias } from '@services/UnidadeGerencia/Index.jsx';
import FilterView from '@components/UI/FilterView/Index.jsx';
import { CustomLoader } from '@components/UI/CustomLoader/Index.jsx';
import { EditOptionComp } from '@components/UI/EditOption/Index.jsx';
import { DeleteOptionComp } from '@components/UI/DeleteOption/Index.jsx';
import ptBR from 'antd/es/locale/pt_BR';
import { StyledTable } from "@styles/datatables/datatable-antd.js";
import TextBlock from '@components/UI/TextBlock/Index..jsx';

const GridUnidadeGerencia = ({ state, setData, openModal, setSelectedRow, onDelete }) => {
  const [filters, setFilters] = useState({
    nome: "",
    sigla: "",
    nomeGerente: "",
    codigo: "",
  });
  const filterLabels = {
    nome: 'NOME UNIDADE/GERÊNCIA',
    sigla: 'SIGLA',
    nomeGerente: 'GERENTE',
    codigo: 'CÓDIGO',
  };
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Busca os dados da API
  const fetchData = async (currentPage, currentRowsPerPage, filters = {}) => {
    setLoading(true);
    try {
      const response = await GetAllUnidadesGerencias(currentPage, currentRowsPerPage, filters);
      setData(response.items, response.totalItems);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  // Atualiza os dados quando a página ou o número de linhas por página muda
  useEffect(() => {
    fetchData(page, rowsPerPage, filters);
  }, [page, rowsPerPage, filters]);

  // Manipula a mudança de página
  const handlePageChange = (newPage, newRowsPerPage) => {
    setPage(newPage);
    if (newRowsPerPage) {
      setRowsPerPage(newRowsPerPage);
    }
  };

  const getConfirmMessage = (row) => {
    return (
      `Você está prestes a <strong>remover</strong> a Unidade/Gerência: <strong>${row.nome}</strong>.
      O Gerente e o Encarregado associados permanecerão no sistema, mas serão desvinculados desta Unidade/Gerência e terão seu status alterado para <strong>Inativo</strong>. Deseja confirmar esta operação?`
    );
  };

  // Colunas da tabela
  const columns = [
    {
      title: 'CÓDIGO',
      dataIndex: 'codigo',
      key: 'codigo',
      width: '15%',
      sorter: (a, b) => a.codigo.localeCompare(b.codigo),
    },
    {
      title: 'SIGLA',
      dataIndex: 'sigla',
      key: 'sigla',
      width: '10%',
      sorter: (a, b) => a.sigla.localeCompare(b.sigla),
    },
    {
      title: 'NOME',
      dataIndex: 'nome',
      key: 'nome',
      width: '25%',
      sorter: (a, b) => a.nome.localeCompare(b.nome), 
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'GERENTE',
      dataIndex: 'nomeGerente',
      key: 'nomeGerente',
      width: '20%',
      sorter: (a, b) => a.nomeGerente.localeCompare(b.nomeGerente),
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'ENCARREGADO',
      dataIndex: 'nomeEncarregado',
      key: 'nomeEncarregado',
      width: '20%',
      sorter: (a, b) => a.nomeEncarregado.localeCompare(b.nomeEncarregado),
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'AÇÕES',
      key: 'actions',
      width: '10%',
      render: (_, record) => (
        <div className="d-flex justify-content-center gap-3">
          <EditOptionComp
            row={record}
            setSelectedRow={setSelectedRow}
            openModal={openModal}
          />
          <DeleteOptionComp
            row={record}
            deleteFunction={DeleteUnidadeGerencia}
            getConfirmMessage={getConfirmMessage}
            onDelete={onDelete}
            itemNameKey={"nome"}
          />
        </div>
      ),
    },
  ];

  return (
    <div className='px-4'>
      <FilterView
        filters={filters}
        setFilters={setFilters}
        filterLabels={filterLabels}
      />

      <div className='mt-3 mb-3'>
        <h1>Lista de Unidades/Gerências Registradas</h1>
      </div>

      <ConfigProvider locale={ptBR}> {/* Localização em português */}
        <StyledTable
          columns={columns}
          dataSource={state.data}
          rowKey={"id"} // Chave única para cada linha
          loading={{
            spinning: loading,
            indicator: <CustomLoader />, // Spinner personalizado
          }}
          pagination={{
            current: page,
            pageSize: rowsPerPage,
            total: state.totalRows, // Total de registros
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            onChange: handlePageChange,
            onShowSizeChange: handlePageChange,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`, // Exibe o total de registros
          }}
          scroll={{ y: '20rem', x: 'max-content' }}
          locale={{
            emptyText: <h2 className='m-3'>Nenhum registro disponível para exibição.</h2>, // Mensagem quando não há dados
          }}
        />
      </ConfigProvider>
    </div>
  );
};

export default GridUnidadeGerencia;